import React, {memo, useEffect} from 'react';
import {LibraryContentWrapper} from '../util/StyledElements';
import RecentContent from './RecentContent';
import CollectionContent from '../collections/CollectionContent';
import Constants from '../../constants/Constants';
import {Route} from 'react-router-dom';
import Analytics from '../../service/analytics';
import useWindowIsAtOrBelowSize from '../../hooks/useWindowIsAtOrBelowSize';
import cssConstants from '../../constants/cssConstants';
import config from '../../service/config';
import {useTscTheme} from '../../context/themeProvider';

export const FeedBase: React.FC<IMyFeedProps> = ({contentSectionId}) => {
   useEffect(() => {
      void Analytics.initialize();
   }, [/* This should remain empty because we only want this to trigger on initial load */]);

   const windowIsAtOrBelowSize = useWindowIsAtOrBelowSize(cssConstants.headerBreakpoint);
   const theme = useTscTheme();

   return (
      <>
         <LibraryContentWrapper
            theme={theme}
            id={contentSectionId}
            isSidebarAbsolutePositioned={!config.feedConfig?.showSidebar || windowIsAtOrBelowSize}
         >
            <Route
               exact
               path={`${Constants.navigation.collectionsViewBasePath}/:id`}
            >
               <CollectionContent isManagementView={false} />
            </Route>
            <Route
               exact
               path={[Constants.navigation.myFeedLink, Constants.navigation.local.myFeedLink]}
            >
               <RecentContent />
            </Route>
         </LibraryContentWrapper>
      </>
   );
};

export interface IMyFeedProps {
   contentSectionId: string;
}

export default memo(FeedBase);
